import { IOpportunity, IOpportunityDetail } from "../../api/opportunity/OpportunitiesApi";
import { Product } from "../product/Product";
import Reseller from "../reseller/Reseller";

export class Opportunity {
  /** The unique identifier for the bid. */
  public bidNumber?: string;
  /** The name or title of the opportunity. */
  public opportunity?: string;
  /** A short description of the opportunity. */
  public description?: string;
  /** The start date of the opportunity, in string format. */
  public startDate?: string;
  /** The end date of the opportunity, in string format. */
  public endDate?: string;
  /** The date of the last update, in string format. */
  public lastUpdate?: string;
  /** A boolean indicating if the opportunity is active. */
  public active?: boolean;
  /** A string containing default resellers. */
  public defaultResellers?: string;
  /** A boolean indicating if this opportunity can be set as a default. */
  public canBeSetAsDefault?: boolean;
  /** The price for the bid. */
  public bidPrice?: number;
  /** The type of the bid price (e.g., 'Rebate', 'SpecialNet'). */
  public bidPriceType?: string;
  /** The Randmar SKU if the opportunity is for a single product. */
  public randmarSKU?: string;

  /** A list of resellers associated with this opportunity. */
  public resellers?: Reseller[];
  /** A list of products and pricing details for this opportunity. */
  public details?: OpportunityDetail[];

  public static convertFrom(source: IOpportunity): Opportunity {
    const opportunity = new Opportunity();

    opportunity.bidNumber = source.BidNumber;
    opportunity.opportunity = source.Opportunity;
    opportunity.startDate = source.StartDate;
    opportunity.endDate = source.EndDate;
    opportunity.lastUpdate = source.LastUpdate;
    opportunity.active = source.Active;
    opportunity.defaultResellers = source.DefaultResellers;
    opportunity.description = source.Description;
    opportunity.canBeSetAsDefault = source.CanBeSetAsDefault;
    opportunity.bidPrice = source.BidPrice;
    opportunity.bidPriceType = source.BidPriceType;
    opportunity.randmarSKU = source.RandmarSKU;

    if (source.Resellers)
      opportunity.resellers = source.Resellers.map(Reseller.convertFrom);

    if (source.Details)
      opportunity.details = source.Details.map(OpportunityDetail.convertFrom);

    return opportunity;
  }
}

export class OpportunityDetail {
  /** The unique identifier for the bid. */
  public bidNumber?: string;
  /** The bid price for this specific product. */
  public bidPrice?: number;
  /** The type of bid price for this product. */
  public bidPriceType?: string;
  /** The Randmar SKU for the product in this detail line. */
  public randmarSKU?: string;

  /** The product associated with this detail line. */
  public product?: Product;

  public static convertFrom(source: IOpportunityDetail): OpportunityDetail {
    const opportunityDetail = new OpportunityDetail();

    opportunityDetail.bidNumber = source.BidNumber;
    opportunityDetail.bidPrice = source.BidPrice;
    opportunityDetail.bidPriceType = source.BidPriceType;
    opportunityDetail.randmarSKU = source.RandmarSKU;

    if (source.Product)
      opportunityDetail.product = Product.convertFrom(source.Product);

    return opportunityDetail;
  }
}
